export function getRDG(cpf) {
  const userRdg = !!cpf ? Number(cpf.slice(6, 9).replace(".", "")) : ""
  return userRdg
}
